import { Box, Text } from '@chakra-ui/react';
import { IconDownload } from '@tabler/icons';
import GenericModal from 'components/modal/genericModal/GenericModal';

import { asyncExportMessages } from './variables/asyncExportMessages';

interface ExportConfirmationModalProps {
	isOpen: boolean;
	onConfirm: () => void;
	onCancel: () => void;
}

export const ExportConfirmationModal = ({
	isOpen,
	onConfirm,
	onCancel,
}: ExportConfirmationModalProps) => {
	return (
		<GenericModal
			isOpen={isOpen}
			onClose={onCancel}
			onCancel={onCancel}
			onSave={onConfirm}
			title={asyncExportMessages.CONFIRMATION_MODAL.title}
			titleIcon={IconDownload}
			titleIconColor='easyRED.300'
			saveButtonText={
				asyncExportMessages.CONFIRMATION_MODAL.confirmButton
			}
			cancelButtonText={
				asyncExportMessages.CONFIRMATION_MODAL.cancelButton
			}
			maxWidth='600px'
			zIndex={2000}
		>
			<Box mt={-6}>
				<Text
					color='gray.500'
					fontSize='sm'
					fontWeight={200}
				>
					{asyncExportMessages.CONFIRMATION_MODAL.description}
				</Text>
			</Box>
		</GenericModal>
	);
};
